import classNames from 'classnames'
import { FunctionComponent } from 'react'

import { OrderStatusCard as OrderStatusCardProps } from './OrderStatusCard.types'
import { OrderCardSummary } from '../OrderCardSummary/OrderCardSummary'

import './OrderStatusCard.scss'
import {
  UXComponentType,
  UXComponentVersion
} from '../UXComponentRenderer/uxComponent.types'
import { UXComponentRenderer } from '../UXComponentRenderer/UXComponentRenderer'
import { Icon } from '../primitives/Icon/Icon'
import { Text } from '../primitives/Text/Text'
import { Label } from '../primitives/Label/Label'
import { Button } from '../primitives/Button/Button'
import { WineOrderDetails } from '../WineOrderDetails/WineOrderDetails'

export const OrderStatusCard: FunctionComponent<OrderStatusCardProps> = ({
  attributes
}) => {
  const callToAction = attributes.ctaButton || attributes.addMealsButton

  return (
    <div
      className="core-ux-order-status-card"
      data-testid="core-ux-order-status-card">
      <div className="core-ux-order-status-card__order-container">
        <div className="core-ux-order-status-card__order-management">
          <div>
            <Label
              {...attributes.statusText}
              className="core-ux-order-status-card__status-text"
            />
            <div className="core-ux-order-status-card__order-management-content">
              <Text
                {...attributes.shippingDate}
                className="core-ux-order-status-card__shipping-date"
              />
              {attributes.statusTag && (
                <Label
                  {...attributes.statusTag}
                  className="core-ux-order-status-card__status-tag"
                />
              )}
            </div>
          </div>
          {attributes.orderManagementButton && (
            <Button
              className="core-ux-order-status-card__order-management-button"
              {...attributes.orderManagementButton}
            />
          )}
        </div>
        {attributes?.steps?.length && (
          <div className="core-ux-order-status-card__steps">
            {attributes.steps.map((step, index) => (
              <div
                className="core-ux-order-status-card__steps-step"
                key={`order-status-card-step-${index}`}
                data-testid="order-status-card-step">
                {step.icon && (
                  <Icon
                    className="core-ux-order-status-card__steps-step-icon"
                    attributes={{
                      asset: step.icon,
                      color: step.barColor,
                      size: 'large'
                    }}
                    type={UXComponentType.Icon}
                    version={UXComponentVersion.V2}
                  />
                )}
                <div
                  className="core-ux-order-status-card__steps-step-line"
                  style={{ backgroundColor: step.barColor }}
                />
              </div>
            ))}
          </div>
        )}
        {(attributes.orderSummary || callToAction) && (
          <div className="core-ux-order-status-card__order-summary-container">
            {attributes.detailText && (
              <Text
                {...attributes.detailText}
                className={classNames(
                  'core-ux-order-status-card__detail-text',
                  attributes.orderSummary
                    ? 'core-ux-order-status-card__detail-text--fill'
                    : ''
                )}
              />
            )}
            <div className="core-ux-order-status-card__order-summary">
              {attributes.orderSummary && (
                <OrderCardSummary
                  type={UXComponentType.OrderCardSummary}
                  version={UXComponentVersion.V2}
                  attributes={attributes.orderSummary}
                />
              )}
              {callToAction && (
                <UXComponentRenderer
                  {...callToAction}
                  className="core-ux-order-status-card__cta-button"
                />
              )}
            </div>
          </div>
        )}
      </div>
      {attributes.winesOrderDetails && (
        <WineOrderDetails attributes={attributes.winesOrderDetails} />
      )}
    </div>
  )
}
